
import {INPUT_TEXT_LIMIT,TEXTAREA_LIMIT } from './GlobalConstents.js';
import * as trans from './FrontMessages';




export const textLimitMessage = () => {
    let message = trans.PLEASE_ENTER_VALID_TEXT_LENGTH;
    let returnString = message.replace(":value", INPUT_TEXT_LIMIT);
    return returnString;
};

export const textAreaLimitMessage = () => {
    let message = trans.PLEASE_ENTER_VALID_TEXT_LENGTH;
    let returnString = message.replace(":value", TEXTAREA_LIMIT);
    return returnString;
};
